import styled from "@emotion/styled";
import { styled as MuiStyled } from "@mui/material/styles";
import { Drawer } from "@mui/material";

//*************************************************//
//********************Emotion**********************//
export const DrawerWrapper = styled.div`
  position: fixed;
  width: 100%;
  z-index: 6;
  padding: 12px 20px;
  border-bottom: 1px solid #5c74b3;
  background: rgb(252 252 252 / 0);
  transition: all 250ms ease-in-out;

  &.stick {
    background: rgb(252 252 252 / 1);
    transition: all 250ms ease-in-out;
    button.hamburger svg rect {
      fill: black;
    }
  }
`;

export const DrawerContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  button.hamburger {
    position: absolute;
    left: 0;
    svg {
      width: 30px;
      height: 30px;
    }
  }
`;

export const DrawerTopMenuWrapper = styled.div`
  background: #17479e;
  padding: 20px;
  .logoWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 25px;
    .logo {
      width: 117px;
    }
    i {
      display: flex;
      cursor: pointer;
    }
  }
  form {
    .MuiInputBase-input::placeholder,
    svg path {
      opacity: 1;
      color: #b9babc;
      fill: #b9babc;
    }
    .MuiInputBase-input {
      color: #fff;
    }
    .MuiInputBase-root {
      background: #1c4ca2;
      border-radius: 4px;
    }
    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
  }
`;

export const DrawerLanguageSwitch = styled.div`
  background: #f9f9f9;
  padding: 20px;
  position: fixed;
  bottom: 0;
  height: 60px;
  width: inherit;
  max-width: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  p {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }
  .buttons {
    background: #e9ecf5;
    border-radius: 30px;
    padding: 4px;
    button {
      border-radius: 38px;
      font-weight: 600;
      font-size: 15px;
      color: #8799c7;
      padding: 3px 7px;
      &.active {
        color: #ffffff;
        background: #17479e;
      }
    }
  }
`;

//***************************************************//
//********************MuiStyled**********************//
export const MuiDrawer = MuiStyled(Drawer)(({ theme, locale }) => ({
  ".MuiPaper-root": {
    width: "100%",
    maxWidth: 600,
    ...(locale === "fa"
      ? {
          right: "unset",
        }
      : {
          left: "unset",
        }),
    ".mainNav": {
      height: "65%",
      overflowY: "scroll",
    },
    ".MuiButtonBase-root": {
      borderBottom: "1px solid #F2F2F3",
      padding: "15px 20px",
    },
    ".MuiListItemIcon-root": {
      minWidth: 24,
      marginRight: 10,
      svg: {
        width: 24,
        height: 24,
      },
    },
    ".MuiListItemText-root .MuiTypography-root": {
      fontWeight: "500",
    },
    ".MuiListItemButton-root:hover": {
      background: "#E9ECF5;",
    },
    ".MuiListItemButton-root.active": {
      background: "#F7F9FF",
      color: "#17479E",
      svg: {
        path: {
          stroke: "#17479E",
        },
      },
    },
    ".MuiCollapse-wrapperInner": {
      // "ul:nth-child(1) > *": {
      //   paddingLeft: 40,
      // },
      // if you want to each nested ul get equal padding use⤴⤴⤴⤴⤴

      ul: {
        ".MuiButtonBase-root": {
          paddingBottom: 10,
          paddingTop: 10,
          paddingLeft: 40,
          ".MuiListItemText-root .MuiTypography-root": {
            fontSize: 14,
          },
        },
        ".MuiCollapse-wrapperInner": {
          ul: {
            ".MuiButtonBase-root": {
              paddingLeft: 80,
            },
          },
        },
      },
    },
    "@media screen and (max-width: 368px)": {
      ".mainNav": {
        height: "59%",
      },
    },
  },
}));
